import ProductsGrid from '../components/Products/ProductsGrid';

const Products = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding bg-gradient-to-r from-primary-500 to-primary-700 text-white">
        <div className="container-custom text-center">
          <h1 className="text-5xl font-bold mb-6">Our Products</h1>
          <p className="text-xl text-primary-100 max-w-3xl mx-auto">
            Innovative technology solutions designed to transform your business operations 
            and drive growth in the digital age.
          </p>
        </div>
      </section>

      <ProductsGrid />

      {/* Product Comparison Section */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <h2 className="text-4xl font-bold text-center mb-12">Compare Our Products</h2>
          <div className="overflow-x-auto">
            <table className="w-full bg-white rounded-2xl shadow-lg">
              <thead>
                <tr className="bg-primary-50">
                  <th className="p-6 text-left text-lg font-semibold text-gray-900">Feature</th>
                  <th className="p-6 text-center text-lg font-semibold text-gray-900">DownloadChow</th>
                  <th className="p-6 text-center text-lg font-semibold text-gray-900">Tally Ride</th>
                  <th className="p-6 text-center text-lg font-semibold text-gray-900">TallyERP 360</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { feature: "Platform", downloadchow: "Mobile App", tallyride: "Mobile/Web", tallyerp: "Desktop/Web" },
                  { feature: "Target Users", downloadchow: "Consumers", tallyride: "Drivers/Riders", tallyerp: "Businesses" },
                  { feature: "Real-time Tracking", downloadchow: "✓", tallyride: "✓", tallyerp: "✓" },
                  { feature: "Payment Integration", downloadchow: "✓", tallyride: "✓", tallyerp: "✓" },
                  { feature: "Analytics Dashboard", downloadchow: "Basic", tallyride: "Advanced", tallyerp: "Enterprise" },
                  { feature: "Multi-language", downloadchow: "✓", tallyride: "✓", tallyerp: "✓" },
                ].map((row, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                    <td className="p-6 font-medium text-gray-900">{row.feature}</td>
                    <td className="p-6 text-center">{row.downloadchow}</td>
                    <td className="p-6 text-center">{row.tallyride}</td>
                    <td className="p-6 text-center">{row.tallyerp}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section-padding bg-gradient-to-r from-primary-500 to-primary-700">
        <div className="container-custom text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-primary-100 mb-8 max-w-2xl mx-auto">
            Contact our sales team to learn more about our products and get a personalized demo.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="btn-secondary bg-white text-primary-700 hover:bg-gray-100">
              Request Demo
            </button>
            <button className="btn-primary bg-white text-primary-700 hover:bg-gray-100 border-white">
              Contact Sales
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;